import React from 'react';
import { useSelector } from 'react-redux';
import { Box, StyledHR, Text } from '@rsos/components/capstone/base';
import {
  GEODETIC_LOCATION,
  CIVIC_LOCATION,
} from '@rsos/constants/providedLocations';
import isLocationRestricted from '@rsos/utils/isLocationRestricted';
import What3words from '../../Location/What3words';
import { HistoricLocationsToggle } from '../../LocationList/HistoricLocationsToggle';
import Altitude from './Altitude';
import { RowBox } from './DataCardLocation.styles';
import DisclaimerCircle from './DisclaimerCircle';
import EstimatedFloorLevel from './EstimatedFloorLevel';
import LatLong from './LatLong';
import LocationAddress from './LocationAddress';
import LocationTime from './LocationTime';
import Uncertainty from './Uncertainty';

const DataCardLocation = ({ alert = {} }) => {
  const {
    civic = {},
    geodetic: geo = {},
    provided_location: providedLocation = '',
  } = alert?.location ?? {};

  const alertTime =
    alert?.location_history?.[0]?.created_at || alert.incident_time;

  const locations = alert?.location_history;
  const { application } = useSelector(state => state.sinatra.user.currentRole);
  const isCentralStation = application === 'central_station';
  const locationsLength = locations?.length;

  const isRestricted = isLocationRestricted(alert);

  return (
    <Box bg="background">
      <Box px="15px" pt="16px" pb="10px">
        <LocationTime
          timeStamp={alertTime}
          color="states"
          timeAgoTextSize="small"
          timeBoxTextSize="xsmall"
        />
        <RowBox>
          <LocationAddress civic={civic} isLocationRestricted={isRestricted} />
          {!isCentralStation && locationsLength > 1 && (
            <HistoricLocationsToggle
              locations={locations}
              selectedAlertID={alert.alert_id}
            />
          )}
        </RowBox>
        {!isRestricted && (
          <>
            <LatLong latitude={geo.latitude} longitude={geo.longitude} />
            {locations && <What3words location={locations[0]} isHoverable />}
            <Uncertainty uncertaintyRadius={geo.uncertainty_radius} />
            <Altitude
              altitude={geo.altitude}
              verticalUncertainty={geo.vertical_uncertainty}
            />
            <EstimatedFloorLevel
              estimatedFloorLevel={geo.estimated_floor_level}
            />
            <RowBox isCompact mt="8px">
              <Text color="secondaryText" size="xsmall">
                {providedLocation === GEODETIC_LOCATION ? (
                  <>
                    <DisclaimerCircle /> Estimated Address based on Lat/Long
                  </>
                ) : providedLocation === CIVIC_LOCATION ? (
                  <>
                    <DisclaimerCircle /> Estimated Lat/Long based on Address
                  </>
                ) : null}
              </Text>
            </RowBox>
          </>
        )}
      </Box>
      <StyledHR
        border="none"
        height="1px"
        width="100%"
        backgroundColor="lightLineDivider"
      />
    </Box>
  );
};

export default DataCardLocation;
